import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Nav, Navbar } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { COLORS } from '../styles/theme'
import routes from '../routes'
import { logoutUser } from '../ducks/auth'
import { showGlobalModal } from '../ducks/layout'
import { NotificationDb } from '../firebaseConfig'
import { useListVals } from 'react-firebase-hooks/database'
import Amplitude from '../utils/amplitudeHelper'
import { GlobalModalTypes } from './GlobalModals/GlobalModalContainer'
import { BiHomeAlt2 } from 'react-icons/bi'
import { LuInfo } from 'react-icons/lu'
import luckyDrawIcon from '../images/pve/lottery-game.svg'
import { MdOutlinePhotoSizeSelectActual } from 'react-icons/md'

const StyledNavbar = styled(Navbar)`
  background: ${COLORS.nav};
  width: 200px;
  position: fixed;
  top: 15vh;
  right: -130px;
  z-index: 50;
  border-bottom-left-radius: 28px;
  border-top-left-radius: 28px;
  transition: 1s;
  display: flex;
  flex-direction: column;
  padding: 0.5rem;

  .nav-label {
    font-size: 13px;
    text-align: left;
    width: 65%;
    display: block;
    color: #525252;
    align-self: center;
  }
  &:hover {
    right: 0;
  }
  .nav-link {
    width: 100%;
    display: flex;
    justify-content: space-between;
    svg,
    span {
      display: block;
    }
    svg {
      width: 26px;
      height: 26px;
    }
  }

  .with-shake {
    animation: wiggle 2s infinite;
  }
`

export default function TopNav({ currentUser }) {
  const location = useLocation()
  const [values, loading] = useListVals(NotificationDb)
  const [unread, setUnread] = useState(false)

  const dispatch = useDispatch()

  useEffect(() => {
    if (values && !loading) {
      if (values.length < localStorage.getItem('IA_notifications')) {
        localStorage.setItem('IA_notifications', 0)
      }
      setUnread(values.length > localStorage.getItem('IA_notifications'))
    }
  }, [values, loading, localStorage.getItem('IA_notifications')])

  const displayNotifications = () => {
    Amplitude.clickNotification()
    dispatch(showGlobalModal(GlobalModalTypes.Notifications))
  }
  const handlePdf = (type) => {
    if (type === 'agenda') {
      dispatch(showGlobalModal(GlobalModalTypes.Agenda))
    } else {
      dispatch(showGlobalModal(GlobalModalTypes.Speakers))
    }
  }

  const showHelpDesk = () => {
    const cpt = window.chaport
    cpt.on('ready', function () {
      cpt.setVisitorData({
        name: currentUser.fullName,
        email: currentUser.email,
      })
      cpt.open()
    })
    cpt.on('collapsed', function () {
      cpt.close()
    })
    Amplitude.clickHelpDesk()
  }

  const handleLogout = () => {
    Amplitude.clickLogout()
    logoutUser(dispatch, currentUser, location.pathname, 'You have logged out')
  }

  return (
    <StyledNavbar>
      <Nav.Link as={Link} to={routes.lobby}>
        <BiHomeAlt2 size={30} className="nav-label" />
        <span className="nav-label">Lobby</span>
      </Nav.Link>

      <Nav.Link onClick={displayNotifications} key="notifications">
        <svg width="25.873" height="26.384" viewBox="0 0 25.873 26.384" className={unread ? 'with-shake' : ''}>
          <g transform="translate(1.25 1.25)">
            <g transform="translate(0)">
              <path
                d="M226.041,376.761v7.8a4.071,4.071,0,0,1-4.093,4.047H207.239a4.071,4.071,0,0,1-4.094-4.047V370.134a4.072,4.072,0,0,1,4.094-4.048h5.892"
                transform="translate(-203.145 -364.721)"
                fill="none"
                stroke="#525252"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
              />
              <ellipse
                cx="5.297"
                cy="5.297"
                rx="5.297"
                ry="5.297"
                transform="translate(12.779)"
                fill={unread ? 'red' : 'none'}
                stroke={unread ? 'red' : '#525252'}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2.5"
              />
            </g>
          </g>
        </svg>
        <span className="nav-label">Notifications</span>
      </Nav.Link>
      <Nav.Link as={Link} to={routes.networking}>
        <svg xmlns="http://www.w3.org/2000/svg" width="30" height="22" viewBox="0 0 30 22" fill="none">
          <path
            d="M3.74987 7.42329C3.74974 6.33556 4.01998 5.26484 4.5363 4.30745C5.05262 3.35007 5.79882 2.53603 6.70778 1.93857C7.61674 1.34111 8.65996 0.978953 9.74361 0.88468C10.8273 0.790408 11.9173 0.966974 12.9158 1.3985C13.9143 1.83002 14.7899 2.50297 15.4637 3.35681C16.1376 4.21066 16.5887 5.21862 16.7764 6.29004C16.9641 7.36146 16.8826 8.46274 16.5391 9.49482C16.1956 10.5269 15.6009 11.4574 14.8086 12.2027C16.3024 12.9279 17.5994 14.0025 18.5897 15.3355C19.58 16.6685 20.2344 18.2206 20.4974 19.8602C20.5263 20.0426 20.519 20.229 20.4759 20.4086C20.4328 20.5883 20.3548 20.7577 20.2462 20.9071C20.1377 21.0566 20.0007 21.1832 19.8432 21.2798C19.6857 21.3763 19.5108 21.4409 19.3283 21.4699C19.1459 21.4988 18.9595 21.4915 18.7798 21.4484C18.6002 21.4053 18.4308 21.3273 18.2813 21.2187C18.1319 21.1101 18.0052 20.9732 17.9087 20.8157C17.8121 20.6582 17.7476 20.4832 17.7186 20.3008C17.4374 18.5389 16.5372 16.9349 15.1798 15.777C13.8224 14.619 12.0966 13.9829 10.3124 13.9829C8.52814 13.9829 6.80236 14.619 5.44493 15.777C4.0875 16.9349 3.18735 18.5389 2.90612 20.3008C2.87706 20.4832 2.81236 20.6582 2.71569 20.8156C2.61902 20.9731 2.49229 21.11 2.34273 21.2184C2.19317 21.3269 2.02371 21.4048 1.84403 21.4478C1.66434 21.4908 1.47795 21.498 1.29549 21.4689C1.11304 21.4399 0.938093 21.3752 0.780645 21.2785C0.623197 21.1818 0.486331 21.0551 0.377861 20.9055C0.26939 20.756 0.19144 20.5865 0.148461 20.4068C0.105481 20.2271 0.0983145 20.0407 0.127369 19.8583C0.389443 18.2188 1.04348 16.6669 2.0339 15.3344C3.02431 14.0018 4.32182 12.9281 5.81612 12.2045C5.16362 11.5908 4.64368 10.85 4.28833 10.0277C3.93297 9.20541 3.74972 8.31908 3.74987 7.42329ZM20.6249 4.61079C21.7143 4.61156 22.78 4.92854 23.6928 5.52326C24.6055 6.11798 25.326 6.96488 25.7667 7.96113C26.2075 8.95739 26.3496 10.0602 26.1757 11.1356C26.0019 12.211 25.5196 13.2129 24.7874 14.0195C25.9293 14.5852 26.9439 15.3778 27.7692 16.3488C28.5945 17.3198 29.2131 18.4489 29.5874 19.667C29.6617 19.9034 29.6722 20.1553 29.6177 20.397C29.5632 20.6387 29.4458 20.8617 29.2772 21.0434C29.1087 21.2251 28.8951 21.3589 28.6582 21.4313C28.4212 21.5038 28.1693 21.5122 27.928 21.4558C27.6868 21.4 27.4645 21.2815 27.2838 21.1123C27.103 20.943 26.9702 20.7291 26.8986 20.492C26.5621 19.4052 25.9495 18.4242 25.1208 17.6447C24.292 16.8652 23.2753 16.3139 22.1699 16.0445C21.8628 15.9704 21.5897 15.7951 21.3944 15.5468C21.1992 15.2985 21.0932 14.9917 21.0936 14.6758V14.0158C21.0935 13.754 21.1664 13.4973 21.3042 13.2747C21.442 13.0521 21.6392 12.8724 21.8736 12.7558C22.4421 12.4741 22.8985 12.0085 23.1689 11.4346C23.4394 10.8607 23.5078 10.2122 23.3631 9.59452C23.2185 8.97682 22.8692 8.42617 22.3721 8.03201C21.875 7.63785 21.2593 7.42333 20.6249 7.42329C20.2519 7.42329 19.8942 7.27514 19.6305 7.01141C19.3668 6.74769 19.2186 6.39001 19.2186 6.01704C19.2186 5.64408 19.3668 5.2864 19.6305 5.02268C19.8942 4.75895 20.2519 4.61079 20.6249 4.61079ZM10.3124 3.67329C9.81298 3.662 9.31637 3.75059 8.8517 3.93387C8.38702 4.11714 7.96364 4.3914 7.60642 4.74055C7.2492 5.0897 6.96533 5.5067 6.77148 5.96706C6.57763 6.42743 6.47772 6.92189 6.47759 7.4214C6.47747 7.92091 6.57714 8.41542 6.77075 8.87588C6.96437 9.33634 7.24803 9.75348 7.60508 10.1028C7.96213 10.4521 8.38537 10.7266 8.84995 10.9101C9.31454 11.0936 9.8111 11.1825 10.3105 11.1714C11.2903 11.1498 12.2227 10.7454 12.9081 10.0448C13.5934 9.34432 13.9773 8.40332 13.9776 7.42327C13.9778 6.44323 13.5944 5.50204 12.9094 4.80117C12.2243 4.1003 11.2922 3.69545 10.3124 3.67329Z"
            fill="#434343"
          />
        </svg>
        <span className="nav-label">Networking</span>
      </Nav.Link>
      <Nav.Link onClick={() => handlePdf('agenda')} key="programme" className="align-items-center">
        <svg width="28" height="26" viewBox="0 0 28 26">
          <g id="Menu" transform="translate(0.383 -0.094)">
            <g transform="translate(0 0)">
              <g transform="translate(0 0)">
                <g transform="translate(-0.383 0.094)" fill="none" stroke="#525252" strokeWidth="2.5">
                  <ellipse cx="14" cy="13" rx="14" ry="13" stroke="none" />
                  <ellipse cx="14" cy="13" rx="12.75" ry="11.75" fill="none" />
                </g>
                <g transform="translate(8.376 8.265)">
                  <path
                    d="M-1571.5,262.678h10.764"
                    transform="translate(1571.5 -262.678)"
                    fill="none"
                    stroke="#525252"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                  />
                  <path
                    d="M-1571.5,262.678h10.764"
                    transform="translate(1571.5 -258.28)"
                    fill="none"
                    stroke="#525252"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                  />
                  <path
                    d="M-1571.5,262.678h10.764"
                    transform="translate(1571.5 -253.882)"
                    fill="none"
                    stroke="#525252"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.5"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
        <span className="nav-label">Programme & Speakers</span>
      </Nav.Link>
      {/* <Nav.Link onClick={() => dispatch(showGlobalModal(GlobalModalTypes.LuckyDraw))} key="programme" className="align-items-center">
        <img src={luckyDrawIcon} alt="Lucky Draw" width="28" height="28" style={{ fill: '#fff' }} />
        <span className="nav-label">Lucky Draw</span>
      </Nav.Link> */}

      {/* <Nav.Link onClick={() => handlePdf('speakers')} key="speakers">
        <svg width="33" height="21" viewBox="0 0 33 21">
          <path
            d="M24.75,19.5A17.98,17.98,0,0,0,18,21a17.694,17.694,0,0,0-6.75-1.5c-3.255,0-9.75,1.62-9.75,4.875V28.5h33V24.375C34.5,21.12,28.005,19.5,24.75,19.5Zm-6,6.75h-15V24.375c0-.81,3.84-2.625,7.5-2.625s7.5,1.815,7.5,2.625Zm13.5,0H21V24.375a2.729,2.729,0,0,0-.78-1.83,14.471,14.471,0,0,1,4.53-.8c3.66,0,7.5,1.815,7.5,2.625ZM11.25,18A5.25,5.25,0,1,0,6,12.75,5.256,5.256,0,0,0,11.25,18Zm0-8.25a3,3,0,1,1-3,3A3.009,3.009,0,0,1,11.25,9.75ZM24.75,18a5.25,5.25,0,1,0-5.25-5.25A5.256,5.256,0,0,0,24.75,18Zm0-8.25a3,3,0,1,1-3,3A3.009,3.009,0,0,1,24.75,9.75Z"
            transform="translate(-1.5 -7.5)"
            fill="#525252"
          />
        </svg>
        <span className="nav-label">Speakers' Profile</span>
      </Nav.Link> */}

      <Nav.Link as={Link} to={routes.onDemand} key="gallery">
        
        <MdOutlinePhotoSizeSelectActual className="nav-label" />
        <span className="nav-label">Gallery</span>
      </Nav.Link>

      <Nav.Link onClick={showHelpDesk} key="helpdesk">
        <LuInfo size={30} className="nav-label" />
        <span className="nav-label">Help Desk</span>
      </Nav.Link>

      <Nav.Link onClick={handleLogout}>
        <svg width="30.797" height="29.609" viewBox="0 0 30.797 29.609">
          <g id="Logout" transform="translate(0 0)">
            <g>
              <g>
                <path
                  d="M311.743,156.064c.012-.014.022-.029.033-.044s.027-.035.039-.053.022-.036.033-.054.02-.033.029-.05.018-.037.027-.056.017-.035.025-.053.014-.037.02-.055.014-.039.021-.059.01-.037.014-.056.011-.04.015-.061.007-.044.01-.065.006-.036.008-.054a1.253,1.253,0,0,0,0-.243c0-.018-.005-.036-.008-.054s-.006-.044-.01-.065-.01-.041-.015-.061-.009-.038-.014-.056-.013-.039-.02-.059-.013-.037-.02-.055-.016-.036-.025-.053-.017-.038-.027-.056-.02-.033-.029-.05-.021-.036-.033-.054-.026-.035-.039-.053-.021-.03-.033-.044c-.026-.031-.053-.061-.081-.09h0l-3.7-3.7a1.234,1.234,0,1,0-1.745,1.745l1.6,1.6H300.92a1.234,1.234,0,1,0,0,2.467h6.891l-1.6,1.6a1.234,1.234,0,0,0,1.745,1.745l3.7-3.7h0Q311.7,156.111,311.743,156.064Z"
                  transform="translate(-281.225 -141.712)"
                  fill="#525252"
                />
                <path
                  d="M21.984,18.277a1.234,1.234,0,0,0-1.234,1.234v6.168H15.816V5.941h0a1.234,1.234,0,0,0-.879-1.182L10.651,3.473h10.1V9.642a1.234,1.234,0,0,0,2.467,0V2.24a1.234,1.234,0,0,0-1.234-1.234H2.245c-.036,0-.073,0-.108,0a1.182,1.182,0,0,0-1.069.859c-.009.028-.016.056-.023.084l0,.009q-.01.044-.017.089l0,.013c0,.028-.007.056-.009.084a1.32,1.32,0,0,0,0,.137V26.914A1.234,1.234,0,0,0,2,28.123L14.34,30.591a1.234,1.234,0,0,0,1.476-1.21V28.147h6.168a1.234,1.234,0,0,0,1.234-1.234v-7.4A1.234,1.234,0,0,0,21.984,18.277Zm-8.636,9.6L3.479,25.9V3.9l9.869,2.961V27.876Z"
                  transform="translate(-1.011 -1.006)"
                  fill="#525252"
                />
              </g>
            </g>
          </g>
        </svg>
        <span className="nav-label">Logout</span>
      </Nav.Link>
    </StyledNavbar>
  )
}
